import { render } from "./ComplianceResubmissionDialog.vue?vue&type=template&id=0b025aab"
import script from "./ComplianceResubmissionDialog.vue?vue&type=script&lang=js"
export * from "./ComplianceResubmissionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__